// Custom actions

/**
 * Handle Print
 * @param action
 * @param component
 */
export const handlePrint = (action, component) => {
    printJobs([{
        url: action.documentLink,
        printerKey: action.printer,
        cookie: action.cookie,
    }]);
}

/**
 * Print document jobs in Electron, or open them in the browser.
 *
 * @param {Array} jobs
 */
export const printJobs = (jobs) => {
    const ipcRenderer = getIpcRenderer();
    jobs.forEach((job) => {
        if (ipcRenderer) {
            ipcRenderer.send('print', job.url, job.printerKey, job.cookie || document.cookie);
            return;
        }
        window.open(job.url, '_blank', 'noopener');
    });
}

/**
 * @returns {Object|null}
 */
const getIpcRenderer = () => {
    if (typeof window.require !== 'function') {
        return null;
    }
    try {
        return window.require('electron').ipcRenderer;
    } catch (error) {
        return null;
    }
}
